export const ip = 'https://5d.gateway.aimirainnovation.com';
// export const ip = 'http://192.168.24.151:48080';
// export const ip = 'http://192.168.12.15';

export const tenant_id = '11341';
